module.exports = __webpack_public_path__ + "static/media/3 07 Tulleord Gjalte er feil.749de09f.mp3";